import * as React from "react";
import { selectAuth } from "src/features/authSlice";
import { useAppSelector } from "src/app/hooks";
import Styles from "./SiteInfo.module.css";
import SafeHtml from "./SafeHtml";

const SiteInfo: React.FC = () => {
  const { acctMessage } = useAppSelector(selectAuth);

  if (!acctMessage) {
    return null;
  }

  return (
    <div className={`${Styles["acct-info-wrapper"]}`}>
      <div className={`${Styles["acct-info"]}`}>
        <div className="me-2">
          <SafeHtml html={acctMessage} />
        </div>
        <div>
          Contact: <a href="mailto:support@dnc.com">support@dnc.com</a> or
          866-DNC-LIST
        </div>
      </div>
    </div>
  );
};

export default SiteInfo;
